module.exports = __webpack_public_path__ + "bornthisday.ffa2d582162f19b41014.jpg";